// extracted by mini-css-extract-plugin
export default {"wrap":"PeriodsListComponent_wrap__kDhED","table":"PeriodsListComponent_table__OP2Bh"};